import {
  Component,
  OnInit
} from '@angular/core';

import {
  Router
} from '@angular/router';

import { UserService, User } from '../../services/user.service';
import { ProfileService } from '../../services/profile.service';
import { NotificationService } from '../../services/notification.service';
import {TranslateService} from '@ngx-translate/core';
//import { Injectable } from '@angular/core';
//import { NestasToolbarComponent } from '../toolbar/toolbar.component';


import * as _ from 'lodash';

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  fileToUpload = null;
  steps = [];
  me = new User();
  hint = { email: false }

  constructor(private _user: UserService, private _router: Router, private _profile: ProfileService, 
    private _notification: NotificationService, public translate: TranslateService) {
    this.steps.push({ name: [translate.instant('TOOLBAR.STEP.PROFILE')], ref: ["profile"] })
  }

  ngOnInit() {

    if (!this._user.isLoggedIn()) {
      this._router.navigate([''], { queryParams: { redirect: 'profile' } });
    } else {
      this._profile.me(true).subscribe(
        (me: any) => this.me = me,
        err => this._notification.errorServer(err)
      );
    }
  }

  updateUseFromEmail(value) {
    if (value && !this.me.fromEmail) {
      this.me.fromEmail = this.me.email;
    }
  }

  updateInformation() {
    this.me.emailVerified = true;
    this._profile.update(this.me).subscribe(
      (ret: any) => {
        if (this.fileToUpload && ret.profile.logo) {
          this._profile.uploadImg(ret.url, this.fileToUpload).subscribe(
            (success: any) => {
              this._notification.success('MESSAGE.SUCCESS', '');
              _.merge(this.me, ret.profile);
            });
        } else {
          this._notification.success('MESSAGE.SUCCESS', '');
          _.merge(this.me, ret.profile);
        }
      },
      err => this._notification.errorServer(err)
    )
  }
  

  fileChangeEvent(fileInput) {
    var file = fileInput.target.files[0];
    this.fileToUpload = fileInput.target.files[0];
    this.me.logo = { type: file.type, name: file.name }
  }

  stopEvent($e) {
    $e.stopPropagation();
    $e.preventDefault();
    return false;
  }
}
